export default __webpack_public_path__ + "static/media/icon-chevron-down.8f35e869.svg";